import Image from "next/image";

import { FC } from "react";

import Box from "@mui/material/Box";

import BorderBottomIcon from "components/Icons/BorderBottom";
import BorderTopIcon from "components/Icons/BorderTop";

import styles from "./styles";

const DiscoveryCard: FC = () => {
  return (
    <Box sx={styles.smartCardTexture}>
      <Box id="ds-sneakers" sx={styles.sneakers}>
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/discovery/sneakers.png`}
          alt=""
          width={584}
          height={584}
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </Box>

      <Box id="ds-border" sx={styles.border}>
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/discovery/border.png`}
          alt=""
          width={584}
          height={584}
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </Box>

      <Box id="ds-cube" sx={styles.cube}>
        <Box
          sx={{
            position: "absolute",
            right: "41%",
            top: "65%",
            width: "124%",
            zIndex: -10,
          }}
        >
          <BorderBottomIcon>BLOCKCHAIN</BorderBottomIcon>
        </Box>
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/discovery/cube.png`}
          alt=""
          width={269}
          height={269}
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </Box>

      <Box id="ds-cart" sx={styles.cart}>
        <Box
          sx={{
            position: "absolute",
            left: "64%",
            top: "30%",
            width: "86%",
            zIndex: -10,
          }}
        >
          <BorderTopIcon>PHYSICAL PRODUCT</BorderTopIcon>
        </Box>
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/discovery/cart.png`}
          alt=""
          width={390}
          height={390}
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </Box>

      <Box id="ds-nfc" sx={styles.nfc}>
        <Box
          sx={{
            position: "absolute",
            right: "28%",
            top: "53%",
            width: "116%",
            zIndex: -10,
          }}
        >
          <BorderBottomIcon>NFC TAG</BorderBottomIcon>
        </Box>
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/discovery/nfc.png`}
          alt=""
          width={318}
          height={318}
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </Box>

      <Box id="ds-nft" sx={styles.nft}>
        <Box
          sx={{
            position: "absolute",
            left: "64%",
            top: "0%",
            width: "150%",
            zIndex: -10,
          }}
        >
          <BorderTopIcon>NFT</BorderTopIcon>
        </Box>
        <Image
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/discovery/nft.png`}
          alt=""
          width={253}
          height={253}
          style={{
            width: "100%",
            height: "auto",
          }}
        />
      </Box>
    </Box>
  );
};

export default DiscoveryCard;
